var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Transition',{attrs:{"name":"zoom"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNotify),expression:"isNotify"}],staticClass:"pastille",class:_vm.small?'small':''})])
}
var staticRenderFns = []

export { render, staticRenderFns }